export const INTERVAL_TYPES = {
  MONTH: 'MONTH',
  YEAR: 'YEAR',
  FIRST_DAY_7TH_MONTH: '1ST_DAY_7TH_MONTH',
  FIRST_DAY_13TH_MONTH: '1ST_DAY_13TH_MONTH',
  FIRST_DAY_25_MONTH: '1ST_DAY_25TH_MONTH',
  FIRST_DAY_37_MONTH: '1ST_DAY_37TH_MONTH',
  LAST_DAY_12_MONTH: 'LAST_DAY_12TH_MONTH',
  LAST_DAY_24_MONTH: 'LAST_DAY_24TH_MONTH',
  LAST_DAY_36_MONTH: 'LAST_DAY_36TH_MONTH',
  DAYS_364: '364_DAYS',
};

export const CERTIFICATE_INTERVAL_OPTIONS = [
  { label: 'Month', value: INTERVAL_TYPES.MONTH },
  { label: 'Year', value: INTERVAL_TYPES.YEAR },
  { label: 'First Day of 7th Month', value: INTERVAL_TYPES.FIRST_DAY_7TH_MONTH },
  { label: 'First Day of 13th Month', value: INTERVAL_TYPES.FIRST_DAY_13TH_MONTH },
  { label: 'First Day of 25th month', value: INTERVAL_TYPES.FIRST_DAY_25_MONTH },
  { label: 'First Day of 37th month', value: INTERVAL_TYPES.FIRST_DAY_37_MONTH },
  { label: 'Last Day of 12th Month', value: INTERVAL_TYPES.LAST_DAY_12_MONTH },
  { label: 'Last Day of 24th Month', value: INTERVAL_TYPES.LAST_DAY_24_MONTH },
  { label: 'Last Day of 36th Month', value: INTERVAL_TYPES.LAST_DAY_36_MONTH },
  { label: '364 Days', value: INTERVAL_TYPES.DAYS_364 },
];

export type IntervalType = typeof INTERVAL_TYPES[keyof typeof INTERVAL_TYPES];
export type Interval = {
  [key in IntervalType]?: number[];
};

export const STATUS_OPTIONS = [
  { value: 'Incomplete', label: 'Incomplete' },
  { value: 'Complete', label: 'Complete' },
  { value: 'Rejected', label: 'Rejected' },
];

export const UPCOMING_STATUS_OPTIONS = [
  { value: 'Upcoming in 30 days', label: 'Upcoming in 30 days' },
  { value: 'Upcoming in 60 days', label: 'Upcoming in 60 days' },
  { value: 'Upcoming in 90 days', label: 'Upcoming in 90 days' },
  { value: 'Upcoming in 120 days', label: 'Upcoming in 120 days' },
];

export const COMPLETE_STATUS = 'Complete';
export const INCOMPLETE_STATUS = 'Incomplete';
export const PENDING_STATUS = 'Pending';
export const REJECTED_STATUS = 'Rejected';
export const EXPIRED_STATUS = 'Expired';
export const OVERRIDDEN_STATUS = 'Overridden';
export const UPCOMING_30_DAYS_STATUS = 'Upcoming in 30 days';
export const UPCOMING_60_DAYS_STATUS = 'Upcoming in 60 days';
export const UPCOMING_90_DAYS_STATUS = 'Upcoming in 90 days';
export const UPCOMING_120_DAYS_STATUS = 'Upcoming in 120 days';

export type STATUS =
  | typeof COMPLETE_STATUS
  | typeof INCOMPLETE_STATUS
  | typeof PENDING_STATUS
  | typeof REJECTED_STATUS
  | typeof EXPIRED_STATUS;

export const PENDING_STATUS_STRUCT = { value: PENDING_STATUS, label: 'Pending review' };
export const EXPIRED_STATUS_STRUCT = { value: EXPIRED_STATUS, label: EXPIRED_STATUS };
export const OVERRIDDEN_STATUS_STRUCT = { value: OVERRIDDEN_STATUS, label: OVERRIDDEN_STATUS };

export const isPilot = (userRoles: string[]) =>
  !userRoles.includes('admin') &&
  !userRoles.includes('owner') &&
  !userRoles.includes('trackedItemsAdmin') &&
  !userRoles.includes('trackedItemsViewer') &&
  userRoles.includes('pilot');
export const isTrackedItemsAdmin = (userRoles: string[]) =>
  userRoles.includes('trackedItemsAdmin') ||
  userRoles.includes('admin') ||
  userRoles.includes('owner');
export const isTrackedItemsViewer = (userRoles: string[]) =>
  userRoles.includes('trackedItemsViewer') && !isTrackedItemsAdmin(userRoles);
export const canViewAllTrackedItems = (userRoles: string[]) =>
  isTrackedItemsAdmin(userRoles) || isTrackedItemsViewer(userRoles);
